<template>
    <div>
        <Navbar Title='To-Do List'/>
        <div class="container">
        <div  class="card">
            <nav class="nav-extended indigo darken-3">
                <div class="nav-content">
                            <router-link :to="{name: 'TodoApp'}">
                                <span class="nav-title" style="padding:0px;margin:10px 20px">To-Do List</span>
                            </router-link>
                </div>
            </nav>


            <div class="add-task container">
                <h2 class="center-align indigo-text">Add New Task</h2>
                <form @submit.prevent="AddTask">
                    <div class="field title">
                        <label for="title">Task Title:</label>
                        <input type="text" name="title" v-model="title">
                    </div>
                    <div class="field add-subtask field" v-for="(subTask,index) in subTasks" :key="index">
                        <label for="subtask">Sub-Task:</label>
                        <input type="text" name="subtask" v-model="subTasks[index]">
                        <i class="material-icons delete" @click="deleteSubTask(subTask)">delete</i>
                    </div>
                    <div class="field add-subtask">
                        <label for="add-subtask">Add Sub-Task:</label>
                        <input type="text" name="add-subtask" @keydown.tab.prevent="addSubtask" v-model="another">
                        <i class="material-icons delete" @click="addSubtask()">add_circle</i>
                    </div>
                    <div class="field center-align">
                        <p v-if="feedback" class="red-text">{{feedback}}</p>
                        <button class="btn pink" style="color:white">Add Task</button>
                    </div>
                </form>
            </div>
        </div></div>
    </div>
</template>

<script>
import db from '@/firebase/init'
import slugify from 'slugify'
import Navbar from '@/components/Navbar.vue'

export default {
    name: 'AddTask',
    components: {
        Navbar,
    },
    data(){
        return{
            title: null,
            another: null,
            subTasks: [],
            feedback: null,
            slug:null,
        }
    },
    methods:{
        AddTask(){
            if(this.title){
                this.feedback=null
                //create slug
                this.slug=slugify(this.title,{
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@#^><{}()]/g,
                    lower: true
                })

                db.collection("Todo-List").add({
                    title:this.title,
                    subTasks:this.subTasks,
                    slug:this.slug
                }).then(() => {
                    this.$router.push({name :'TodoApp'})
                }).catch(err =>{
                    console.log(err)
                })
            }
            else{
                this.feedback="Title cannot be empty"
            }
        },
        addSubtask()
        {
            if(this.another)
            {
                this.subTasks.push(this.another)
                this.another= null
                this.feedback=null
            }else{
                this.feedback="You must add a Sub-Task"
            }
        },
        deleteSubTask(subTask)
        {
            this.subTasks=this.subTasks.filter(subtask=>{
                return subtask!=subTask
            })
        }
    }
}
</script>

<style scoped>
.add-task{
    margin-top: 60px;
    padding: 20px;
    max-width: 500px;
}

.add-task h2{
    font-size: 2em;
    margin: 20px auto;
}
.add-task .field{
    position: relative;
    margin: 20px auto;
}

.add-task .delete{
    position: absolute;
    right: 0px;
    bottom: 16px;
    color: #aaa;
    font-size:1.4em;
    cursor: pointer;
}
</style>